import { notification } from 'antd'
import axios from 'axios'
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_SMA,
  timeout: 1000 * 60 * 3000
})
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('smaToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('smaToken')
      window.location.href = '/'
    }
    return Promise.reject(error)
  }
)

export const getSma = async (url, retries = 4) => {
  try {
    const response = await instance.get(url);
    return response.data;
  } catch (error) {
    if (error.response?.status === 502 && retries > 0) {
      return getSma(url, retries - 1);
    }
    notification.error({
      message: error.response?.data?.error?.message || "An error occurred",
    });
    return null;
  }
};

export const postSma = async (url, data, show = true, retries = 3) => {
  try {
    const response = await instance.post(url, data);
    return response.data;
  } catch (error) {
    if (error.response?.status === 502 && retries > 0) {
      return postSma(url, data, show, retries - 1);
    }

    if (show) {
      notification.error({
        message: error.response?.data?.error?.message || "An error occurred",
      });
    }

    return null;
  }
};

export const putSma = async (url, data, retries = 3) => {
  try {
    const response = await instance.put(url, data, { timeout: 1000000 });
    return response.data;
  } catch (error) {
    if (error.response?.status === 502 && retries > 0) {
      return putSma(url, data, retries - 1);
    }

    console.log(error);
    notification.error({
      message: error.response?.data?.error?.message || "An error occurred",
    });

    return null;
  }
};

export const deleteReqSma = async (url, data = null, retries = 3) => {
  try {
    const response = await instance.delete(url, { data });
    return response.data;
  } catch (error) {
    if (error.response?.status === 502 && retries > 0) {
      return deleteReqSma(url, data, retries - 1);
    }

    if (error.response) {
      notification.error({
        message: error.response?.data?.error?.message || "An error occurred",
      });
    }

    return null;
  }
};

